
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 56 56","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('mask',{attrs:{"id":"a","maskUnits":"userSpaceOnUse","x":"0","y":"0","width":"56","height":"56"}},[_c('path',{attrs:{"d":"M28 0a14 14 0 110 28 14 14 0 010-28zm0 35c15.47 0 28 6.265 28 14v7H0v-7c0-7.735 12.53-14 28-14z"}})]),_c('g',{attrs:{"mask":"url(#a)"}},[_c('circle',{attrs:{"cx":"28","cy":"20","r":"36","fill":"#fff"}})])])
          )
        }
      }
    